export const stopPropagation = (evt?: React.SyntheticEvent) =>
  evt?.stopPropagation();
